module.exports = __webpack_public_path__ + "static/media/balmain_4.ccf9d30e.jpg";